<template>
  <div class="container">
    <h3 class="pt-4">Datos personales</h3>
    <hr class="pb-4" />
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <h6>Tipo de identificación</h6>
        <b-form-select
          id="licenseType"
          v-model="form.identification_type_id"
          :options="idTypes"
          @change="resetGovId()"
        >
        </b-form-select>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>Número de identificación</h6>
        <div class="input-group pb-3">
          <input
            type="number"
            class="form-control"
            v-model="form.gov_id"
            @change="resetName()"
            v-on:keyup.enter="loadPerson()"
          />
          <div
            class="input-group-append"
            v-if="form.identification_type_id == 1"
          >
            <button
              class="btn btn-outline-primary"
              id="searchName"
              type="button"
              :disabled="!isValidGovId()"
              @click="loadPerson()"
            >
              Buscar
            </button>
          </div>
          <div class="text-center" v-if="loadingPerson">
            <div class="spinner-border" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Nacionalidad">
          <b-form-select
            id="nationality"
            v-model="form.country_id"
            :options="countryCodes"
          >
          </b-form-select>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Nombre">
          <b-input-group>
            <b-form-input
              type="text"
              v-model="form.first_name"
              placeholder="Nombre"
              @blur="$v.form.first_name.$touch()"
              :state="
                $v.form.first_name.$dirty ? isValidValue(form.first_name) : null
              "
            >
            </b-form-input>

            <b-form-invalid-feedback
              id="name-feedback"
              v-if="!isValidValue(form.first_name)"
            >
              Por favor ingrese su nombre
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Primer Apellido">
          <b-input-group>
            <b-form-input
              type="text"
              v-model="form.last_name"
              placeholder="Primer apellido"
              @blur="$v.form.last_name.$touch()"
              :state="
                $v.form.last_name.$dirty ? isValidValue(form.last_name) : null
              "
            >
            </b-form-input>
            <b-form-invalid-feedback
              id="lastName-feedback"
              v-if="!isValidValue(form.last_name)"
            >
              Por favor ingrese su primer apellido
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Segundo Apellido">
          <b-input-group>
            <b-form-input
              type="text"
              v-model="form.sur_name"
              placeholder="Segundo apellido"
              @blur="$v.form.sur_name.$touch()"
              :state="
                $v.form.sur_name.$dirty ? isValidValue(form.sur_name) : null
              "
            >
            </b-form-input>
            <b-form-invalid-feedback
              id="surName-feedback"
              v-if="!isValidValue(form.sur_name)"
            >
              Por favor ingrese su segundo apellido
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Fecha de nacimiento">
          <b-form-input
            id="birthdate"
            type="date"
            :min="minDate"
            :max="maxDate"
            v-model="form.birthdate"
            required
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Número celular">
          <b-form-input
            v-model="form.cell_phone"
            @blur="$v.form.cell_phone.$touch()"
            :state="
              $v.form.cell_phone.$dirty
                ? isValidCellPhone() && isValidValue(form.cell_phone)
                : null
            "
            :maxlength="9"
            v-mask="'####-####'"
            placeholder="Celular"
          >
          </b-form-input>
          <b-form-invalid-feedback
            id="cellphone-feedback-1"
            v-if="!isValidValue(form.cell_phone)"
          >
            Por favor ingrese su número de celular
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            id="cellphone-feedback-2"
            v-if="!isValidCellPhone() && isValidValue(form.cell_phone)"
          >
            El celular ingresado es inválido
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Teléfono de habitación">
          <b-form-input
            v-model="form.phone"
            :maxlength="9"
            v-mask="'####-####'"
            placeholder="Teléfono"
            @blur="$v.form.phone.$touch()"
            :state="$v.form.phone.$dirty ? isValidValue(form.phone) : null"
          >
          </b-form-input>
          <b-form-invalid-feedback id="phone-feedback-2" v-if="!isValidPhone()">
            El teléfono ingresado es inválido
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Correo electrónico">
          <b-form-input
            @blur="$v.form.email.$touch()"
            :state="
              $v.form.email.$dirty
                ? isValidEmail(form.email) && isValidValue(form.email)
                : null
            "
            v-model="form.email"
            placeholder="Correo electrónico"
            type="email"
          >
          </b-form-input>
          <b-form-invalid-feedback
            id="email-feedback-1"
            v-if="!isValidValue(form.email)"
          >
            Por favor ingrese su correo electrónico
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            id="email-feedback-2"
            v-if="!isValidEmail(form.email) && isValidValue(form.email)"
          >
            El correo ingresado es inválido
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Imagen de perfil">
          <b-form-file
            ref="image-input"
            browse-text="Buscar"
            type="file"
            @change="onImageChange('image_url', 'loadingImage')"
            placeholder="Por favor elija una imagen"
          >
          </b-form-file>
          <span v-if="form.image_url == null" style="color: #d60000">
            *Imagen de perfil requerida</span
          >
        </b-form-group>
        <div class="text-center" v-if="loadingImage">
          <div class="spinner-border" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Curriculum vitae">
          <b-form-file
            browse-text="Buscar"
            type="file"
            ref="file-input"
            @change="onFileChange('cv', 'loadingCV')"
            placeholder="Por favor elija un archivo"
          >
          </b-form-file>
          <span v-if="form.cv == null" style="color: #d60000">
            * Curriculum vitae requerido</span
          >
        </b-form-group>
        <div class="text-center" v-if="loadingCV">
          <div class="spinner-border" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Tipo de sangre">
          <b-form-select v-model="form.blood_type_id" :options="bloodTypes">
          </b-form-select>
        </b-form-group>
      </div>
      <div class="col-md-7 col-sm-12 pl-3">
        <b-form-group class="form-label" label="Genero">
          <input
            type="radio"
            class="mr-2 "
            v-model="form.gender_id"
            value="1"
          />Masculino
          <input
            type="radio"
            class="mr-2 ml-3"
            v-model="form.gender_id"
            value="2"
          />Femenino
          <input
            type="radio"
            class="mr-2 ml-3"
            v-model="form.gender_id"
            value="3"
          />Otro
        </b-form-group>
      </div>
    </div>

    <div class="row pt-2">
      <div class="col-md-6 col-sm-12">
        <b-form-group
          class="form-label"
          label="Tipo de puesto al que desea aplicar"
        >
          <multiselect
            :multiple="true"
            v-model="form.positions"
            :options="jobTypes"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            label="name"
            placeholder="Tipo de puesto"
            track-by="id"
          >
          </multiselect
        ></b-form-group>
      </div>
      <div class="col-md-6 col-sm-12">
        <b-form-group
          class="form-label"
          label="Seleccione la o las licencias que posee"
        >
          <multiselect
            :multiple="true"
            v-model="driving_licenses_temp"
            :options="groupedLicenses"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            group-values="types"
            group-label="label"
            label="license_id"
            placeholder="Selecciona una licencia"
            track-by="number"
          >
          </multiselect
        ></b-form-group>
      </div>
    </div>

    <div class="row pt-2">
      <div class="col-md-4 col-sm-12">
        <b-form-group class="form-label" label="Transporte propio">
          <input
            type="radio"
            class="mr-2 "
            v-model="form.own_transport"
            value="true"
          />Sí
          <input
            type="radio"
            class="mr-2 ml-3"
            v-model="form.own_transport"
            value="false"
          />No
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12 pl-3">
        <b-form-group
          class="form-label"
          label="Disponibilidad a trabajar en otra región"
        >
          <input
            type="radio"
            class="mr-2 "
            v-model="form.willing_to_move"
            value="true"
          />Sí
          <input
            type="radio"
            class="mr-2 ml-3"
            v-model="form.willing_to_move"
            value="false"
          />No
        </b-form-group>
      </div>
      <div class="col-md-4 col-sm-12 pl-3">
        <b-form-group class="form-label" label="Portación de armas al día">
          <input
            type="radio"
            class="mr-2 "
            v-model="form.up_to_date_portation"
            value="true"
          />Sí
          <input
            type="radio"
            class="mr-2 ml-3"
            v-model="form.up_to_date_portation"
            value="false"
          />No
        </b-form-group>
      </div>
    </div>

    <div id="content" class="pb-5">
      <div class="row"></div>
      <br />
      <h5 style="text-align: left">Dirección de residencia</h5>
      <hr />

      <div class="row">
        <div class="col-md-4 col-sm-12">
          <b-form-group class="form-label" label="Provincia">
            <b-form-select
              id="province"
              v-model="form.province_id"
              @blur="$v.form.province_id.$touch()"
              :state="
                $v.form.province_id.$dirty
                  ? isValidValue(form.province_id)
                  : null
              "
              @change="loadCantons()"
              :options="provinces"
              value-field="id"
              text-field="name"
            >
            </b-form-select>
            <b-form-invalid-feedback id="province">
              Seleccione la provincia donde reside actualmente
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-md-4 col-sm-12">
          <b-form-group class="form-label" label="Cantón">
            <b-input-group id="cgroup" class="pb-2 pr-sm-2 pb-sm-0">
              <b-form-select
                id="canton"
                v-model="form.canton_id"
                @blur="$v.form.canton_id.$touch()"
                :state="
                  $v.form.canton_id.$dirty ? isValidValue(form.canton_id) : null
                "
                @change="loadDistricts(), loadPostOfficeLocations()"
                :disabled="cantons.length == 0"
                :options="cantons"
                value-field="id"
                text-field="name"
              >
              </b-form-select>
              <b-form-invalid-feedback
                id="canton-feedback"
                v-if="cantons.length > 0"
              >
                Seleccione el cantón donde vive
              </b-form-invalid-feedback>
              <div class="text-center" v-if="loadingCantons">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
              </div>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-4 col-sm-12">
          <b-form-group class="form-label" label="Distrito">
            <b-input-group id="dgroup" class="pb-2 pr-sm-2 pb-sm-0">
              <b-form-select
                id="district"
                v-model="form.district_id"
                @blur="$v.form.district_id.$touch()"
                :state="
                  $v.form.district_id.$dirty
                    ? isValidValue(form.district_id)
                    : null
                "
                :disabled="districts.length == 0"
                :options="districts"
                value-field="id"
                text-field="name"
              >
              </b-form-select>
              <b-form-invalid-feedback
                id="district-feedback"
                v-if="districts.length > 0"
              >
                Seleccione el cantón donde vive
              </b-form-invalid-feedback>
              <div class="text-center" v-if="loadingDistricts">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
              </div>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-12 col-sm-12">
          <b-form-group class="form-label" label="Detalles de la dirección">
            <b-form-textarea
              v-model="form.address_detail"
              min="0"
              placeholder="Detalle dirección"
            >
            </b-form-textarea>
          </b-form-group>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-12 col-sm-12">
      <div class="column no-padding">
        <GmapMap
          v-if="loadedLocation"
          :center="center"
          @click="mark"
          :zoom="13"
          ref="mapRef"
          :options="{
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUI: false,
          }"
          style="width: 100%; height: 330px"
        >
          <GmapMarker
            :position="marker"
            :clickable="true"
            :draggable="true"
          />
        </GmapMap>
      </div>
    </div> -->
    <br />
    <br />
    <div class="row justify-content-center">
      <button
        class="button"
        type="button"
        :disabled="!isValidForm()"
        v-on:click="saveData()"
      >
        ENVIAR INFORMACIÓN
      </button>
    </div>
    <b-modal id="save-modal" centered hide-footer hide-header>
      <div class="row justify-content-center">
        <img src="../assets/logo_ops.png" alt="K9 Logo" width="150" />
      </div>
      <br />
      <div class="d-block text-center">
        <span style="font-size:20px">
          ¡La información ha sido guardada exitosamente! <br />
          En caso de que su perfil sea compatible con alguno de nuestras
          vacantes, será contactado por el personal de Recursos Humanos de K-9
          Internacional.
        </span>
      </div>
      <div class="text-center">
        <b-button
          block
          class="pt-3"
          variant="dark"
          @click="$bvModal.hide('save-modal')"
          >Cerrar</b-button
        >
      </div>
    </b-modal>
    <b-modal id="name-error-modal" centered hide-footer hide-header>
      <div class="row justify-content-center">
        <img src="../assets/logo_ops.png" alt="K9 Logo" width="150" />
      </div>
      <br />
      <div class="d-block text-center">
        <span style="font-size:20px">
          Ha ocurrido un error. <br />Por favor vuelva a intentar.
        </span>
      </div>
      <div class="text-center">
        <b-button
          block
          class="pt-3"
          variant="dark"
          @click="$bvModal.hide('name-error-modal')"
          >Cerrar</b-button
        >
      </div>
    </b-modal>
    <b-modal id="error-modal" centered hide-footer hide-header>
      <div class="row justify-content-center">
        <img src="../assets/logo_ops.png" alt="K9 Logo" width="150" />
      </div>
      <br />
      <div class="d-block text-center">
        <span style="font-size:20px">
          Ha ocurrido un error al guardar la información. <br />Por favor vuelva
          a intentar.
        </span>
      </div>
      <div class="text-center">
        <b-button
          block
          class="pt-3"
          variant="dark"
          @click="$bvModal.hide('error-modal')"
          >Cerrar</b-button
        >
      </div>
    </b-modal>
    <b-modal id="file-size-modal" centered hide-footer hide-header>
      <div class="row justify-content-center">
        <img src="../assets/logo_ops.png" alt="K9 Logo" width="150" />
      </div>
      <br />
      <div class="d-block text-center">
        <span style="font-size:20px">
          Archivo muy grande. Tamaño máximo 1MB
        </span>
      </div>
      <div class="text-center">
        <b-button
          block
          class="pt-3"
          variant="dark"
          @click="$bvModal.hide('file-size-modal')"
          >Cerrar</b-button
        >
      </div>
    </b-modal>
    <b-modal id="file-error-modal" centered hide-footer hide-header>
      <div class="row justify-content-center">
        <img src="../assets/logo_ops.png" alt="K9 Logo" width="150" />
      </div>
      <br />
      <div class="d-block text-center">
        <span style="font-size:20px">
          Error al subir el archivo.
        </span>
      </div>
      <div class="text-center">
        <b-button
          block
          class="pt-3"
          variant="dark"
          @click="$bvModal.hide('file-error-modal')"
          >Cerrar</b-button
        >
      </div>
    </b-modal>
    <b-modal id="repeated-candidate-modal" centered hide-footer hide-header>
      <div class="row justify-content-center">
        <img src="../assets/logo_ops.png" alt="K9 Logo" width="150" />
      </div>
      <br />
      <div class="d-block text-center">
        <span style="font-size:20px">
          Ya existe un candidato asociado a este número de cédula.
        </span>
      </div>
      <div class="text-center">
        <b-button
          block
          class="pt-3"
          variant="dark"
          @click="$bvModal.hide('repeated-candidate-modal')"
          >Cerrar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import {
  BLOOD_TYPES,
  COUNTRIES,
  ID_TYPES,
  // JOB_TYPES,
  ALL_LICENSE_TYPES_BY_GROUPS,
} from "../constants";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  name: "StepOne",
  components: {},
  data() {
    return {
      loadingImage: false,
      loadingCV: false,
      bloodTypes: BLOOD_TYPES,
      idTypes: ID_TYPES,
      jobTypes: [],
      // jobTypes: JOB_TYPES,
      groupedLicenses: ALL_LICENSE_TYPES_BY_GROUPS,
      center: {
        lat: 9.979304,
        lng: -84.0881,
      },
      saved: false,
      countryCodes: [],
      provinces: [],
      cantons: [],
      districts: [],
      postOfficeLocations: [],
      uploadingImage: true,
      loadedLocation: true,
      loadingProvinces: false,
      loadingCantons: false,
      loadingDistricts: false,
      loadingPostOffices: false,
      loadingPerson: false,
      loadingJobTypes: false,
      tempUrl: {},
      marker: {
        lng: -84.003,
        lat: 10.02708,
      },
      minDate: null,
      maxDate: null,
      driving_licenses: [],
      driving_licenses_temp: [],
      form: {
        // step: 1,
        identification_type_id: 1,
        gov_id: "",
        first_name: "",
        last_name: "",
        sur_name: "",
        phone: "",
        birthdate: "",
        cell_phone: "",
        email: "",
        image_url: null,
        cv: null,
        gender_id: 1,
        blood_type_id: null,
        country_id: null,
        province_id: null,
        canton_id: null,
        district_id: null,
        address_detail: "",
        // latitude: "",
        // longitude: "",
        positions: [],
        willing_to_move: "",
        up_to_date_portation: "",
        own_transport: "",
      },
    };
  },
  validations: {
    form: {
      identification_type_id: {
        required,
      },
      gov_id: {
        required,
      },
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      sur_name: {
        required,
      },
      phone: {
        required,
      },
      birthdate: {
        required,
      },
      cell_phone: {
        required,
      },
      email: {
        required,
      },
      image_url: {
        required,
      },
      cv: {
        required,
      },
      gender_id: {
        required,
      },
      blood_type_id: {
        required,
      },
      country_id: {
        required,
      },
      // driving_licenses: {
      //   required,
      // },
      province_id: {
        required,
      },
      canton_id: {
        required,
      },
      district_id: {
        required,
      },
    },
  },
  watch: {
    clickedNext(val) {
      if (val === true) {
        this.$v.form.$touch();
      }
    },
  },

  mounted() {
    this.form.identification_type_id = 1;
    this.form.country_id = "CR";
    this.countryCodes = [...COUNTRIES];
    this.loadProvinces();
    this.loadRolePositions();
    this.getDates();
  },

  methods: {
    getDates() {
      const today = new Date();
      const yyyy = today.getFullYear();
      this.minDate = yyyy - 50 + "-1-1";
      this.maxDate = yyyy - 18 + "-12-31";
    },

    mark(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.marker = {
        lat: lat,
        lng: lng,
      };
    },

    isValidEmail(email) {
      if (email != "") {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email) ? true : false;
      }
      return false;
    },

    isValidCellPhone() {
      let phone = this.form.cell_phone;
      if (phone != "") {
        var re = /^\d{4}-\d{4}$/;
        var res = re.test(phone);
        return res ? true : false;
      }
      return false;
    },

    isValidPhone() {
      let phone = this.form.phone;
      if (phone != "") {
        var re = /^\d{4}-\d{4}$/;
        var res = re.test(phone);
        return res ? true : false;
      }
      return false;
    },

    isValidValue(value) {
      if (!value) return false;
      if (value === "") return false;
      if (value === null) return false;
      if (value === undefined) return false;
      if (value == "undefined") return false;
      return true;
    },

    isValidGovId() {
      const govId = this.form.gov_id;
      if (this.form.gov_id < 0) {
        return false;
      }
      const amount = govId ? govId.length : 0;
      return amount > 8;
    },

    loadProvinces() {
      this.loadingProvinces = true;
      axios
        .get(`${process.env.VUE_APP_SERVER_ENDPOINT}/provinces`)
        .then((response) => {
          let results = response.data;
          if (results) {
            this.provinces = results.results;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingProvinces = false;
        });
    },

    loadCantons() {
      const provinceId = this.form.province_id;
      if (provinceId) {
        this.loadingCantons = true;
        axios
          .get(
            `${process.env.VUE_APP_SERVER_ENDPOINT}/cantons?provinceId=${provinceId}`
          )
          .then((response) => {
            let results = response.data;
            if (results) {
              this.cantons = results.results;
            }
          })
          .catch(() => {
            this.form.first_name = "- -";
          })
          .finally(() => {
            this.loadingCantons = false;
          });
      }
      this.form.canton_id = null;
      this.form.district_id = null;
    },

    loadDistricts() {
      const provinceId = this.form.province_id;
      const cantonId = this.form.canton_id;
      if (provinceId && cantonId) {
        this.loadingDistricts = true;
        axios
          .get(
            `${process.env.VUE_APP_SERVER_ENDPOINT}/districts?provinceId=${provinceId}&cantonId=${cantonId}`
          )
          .then((response) => {
            let results = response.data;
            if (results) {
              this.districts = results.results;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loadingDistricts = false;
          });
      }
    },

    loadPostOfficeLocations() {
      const province_id = this.form.province_id;
      const canton_id = this.form.canton_id;
      if (province_id && canton_id) {
        this.loadingPostOffices = true;
        axios
          .get(
            `${process.env.VUE_APP_SERVER_ENDPOINT}/postOfficeLocations?canton_id=${canton_id}&province_id=${province_id}`
          )
          .then((response) => {
            let results = response.data;
            if (results) {
              this.postOfficeLocations = results;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loadingPostOffices = false;
          });
      }
    },

    onImageChange(destination, loader) {
      this[loader] = true;
      const files = event.target.files;
      if (files.length > 0) {
        const uFile = files[0];
        // if (uFile.size < 1048576) {
        if (uFile) {
          const formData = new FormData();
          formData.append("file", uFile);
          axios
            .post(
              `${process.env.VUE_APP_SERVER_ENDPOINT}/uploadImage`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((response) => {
              // console.log(response);
              // console.log(response.data.url);
              this.form[destination] = response.data.url;
              // console.log(this.form[destination]);
            })
            .catch(() => {
              // console.log(err);
              this.$bvModal.show("file-error-modal");
              this[loader] = false;
            })
            .finally(() => {
              this[loader] = false;
            });
        }
        // } else {
        //   this.$bvModal.show("file-size-modal");
        //   this[loader] = false;
        // }
      }
    },

    onFileChange(destination, loader) {
      const files = event.target.files;
      if (files.length > 0) {
        this[loader] = true;
        const uFile = files[0];
        // if (uFile.size < 1048576) {
        if (uFile) {
          const formData = new FormData();
          formData.append("file", uFile);
          axios
            .post(
              `${process.env.VUE_APP_SERVER_ENDPOINT}/uploadFile`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((response) => {
              this.form[destination] = response.data;
              // console.log(this.form[destination]);
            })
            .catch(() => {
              this.$bvModal.show("file-error-modal");
              this[loader] = false;
            })
            .finally(() => {
              this[loader] = false;
            });
        }
        // } else {
        //   this.$bvModal.show("file-size-modal");
        //   this[loader] = false;
        // }
      }
    },

    getProvinceName() {
      for (let idx = 0; idx < this.provinces.length; idx++) {
        const province = this.provinces[idx];
        if (+province.id === +this.form.province_id) {
          return province.name;
        }
      }
    },

    resetGovId() {
      this.form.gov_id = "";
    },

    resetName() {
      this.form.first_name = "";
      this.form.last_name = "";
      this.form.sur_name = "";
    },

    loadPerson() {
      if (!this.isValidGovId()) {
        return;
      }
      this.loadingPerson = true;
      axios
        .get(
          `${process.env.VUE_APP_SERVER_ENDPOINT}/persons/${this.form.gov_id}`
        )
        .then((response) => {
          let results = response.data;
          if (results) {
            const name = results;
            this.form.first_name = name.first_name;
            this.form.last_name = name.last_name;
            this.form.sur_name = name.sur_name;
          }
        })
        .catch(() => {
          this.$bvModal.show("name-error-modal");
        })
        .finally(() => {
          this.loadingPerson = false;
        });
    },

    isValidForm() {
      for (const x in this.form) {
        if (this.form[x] == null || this.form[x] == "") {
          return false;
        }
      }
      return true;
    },

    transformLicenses() {
      let temp = [];
      this.driving_licenses_temp.forEach((x) => {
        let char = x.license_id.split("");
        temp.push({
          number: +char[1],
          license_id: char[0],
        });
        console.log(temp);
      });
      this.driving_licenses = temp;
    },
    loadRolePositions() {
      this.loadingJobTypes = true;
      axios
        .get(
          `${process.env.VUE_APP_SERVER_ENDPOINT}/rolePositions`
        )
        .then((response) => {
          let results = response.data;
          if (results) {
            this.jobTypes = results.results;
            const position = this.$route.query.puesto;
            if (position) {
              const foundPosition = this.jobTypes.find(
                (x) => x.slug == position
              );
              if (foundPosition) {
                this.form.positions = [foundPosition];
              }
            }
          }
        })
        .catch(() => {
          this.form.jobTypes = [];
        })
        .finally(() => {
          this.loadingJobTypes = false;
        });
    },
    saveData() {
      this.transformLicenses();
      const data = {
        driving_licenses: this.driving_licenses,
        ...this.form,
      };
      axios
        .post(`${process.env.VUE_APP_SERVER_ENDPOINT}/candidate`, data)
        .then(() => {
          this.$bvModal.show("save-modal");
          this.form = [];
          this.driving_licenses_temp = [];
          this.$refs["file-input"].reset();
          this.$refs["image-input"].reset();
          this.form.identification_type_id = 1;
          this.form.country_id = "CR";
          this.$v.form.first_name.$reset();
          this.$v.form.last_name.$reset();
          this.$v.form.sur_name.$reset();
          this.$v.form.phone.$reset();
          this.$v.form.cell_phone.$reset();
          this.$v.form.email.$reset();
        })
        .catch((error) => {
          if (error.response.data === "Existent candidate") {
            this.$bvModal.show("repeated-candidate-modal");
          } else {
            this.$bvModal.show("error-modal");
          }
        });
    },
  },
};
</script>

<style scoped>
.container {
  margin-bottom: 20px;
  height: 100%;
}
.preview {
  max-height: 200px;
  object-fit: contain;
}
.name {
  text-transform: uppercase;
}
</style>
